import API, {config} from './_main';
import * as ReportModule from 'Modules/ReportModule';
import {AxiosPromise} from 'axios';

export function getCarMainReport(params?: URLSearchParams): AxiosPromise<ReportModule.Types.CarMainReport> {
    return API.get('report/info/main-car-report', config(params));
}

export function getTerminalInstallationReport(params?: URLSearchParams): AxiosPromise<ReportModule.Types.TerminalInstallationReport> {
    return API.get('/report/installations-report/info', config(params));
}

export function getActiveTerminalsReport(params?: URLSearchParams): AxiosPromise<ReportModule.Types.ActiveTerminalsReport> {
    return API.get('/report/active-terminals-report/info', config(params));
}

export function getVehiclesStateReport(params?: URLSearchParams): AxiosPromise<ReportModule.Types.VehiclesStateReport> {
    return API.get('/report/vehicles-state/info', config(params));
}

export function getCarParkingReport(params?: URLSearchParams): AxiosPromise<ReportModule.Types.CarParkingReport> {
    return API.get('report/info/car-parkings-report', config(params));
}

export function getCarRideReport(params?: URLSearchParams): AxiosPromise<ReportModule.Types.CarRidesReport> {
    return API.get('report/info/car-rides-report', config(params));
}

export function getReportFile(params?: URLSearchParams, type?: ReportModule.EnumTypes.ReportType) {
    if (type === ReportModule.EnumTypes.ReportType.TERMINAL_INSTALLATION_REPORT) {
        return API.get(`report/installations-report/file?${params.toString()}`, {responseType: 'blob'});
    } else if (type === ReportModule.EnumTypes.ReportType.ACTIVE_TERMINALS_REPORT) {
        return API.get(`report/active-terminals-report/file?${params.toString()}`, {responseType: 'blob'});
    } else if (type === ReportModule.EnumTypes.ReportType.VEHICLES_STATE_REPORT) {
        return API.get(`report/vehicles-state/file?${params.toString()}`, {responseType: 'blob'});
    }

    return API.get(`report/file?${params.toString()}`, {responseType: 'blob'});
}



// WEBPACK FOOTER //
// ./src/Connectors/ReportConnector.ts